exports = module.exports = require("../../../../../../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".contentContainer___2IU4c {\n  max-width: 1200px;\n  padding: 60px;\n  margin-left: auto;\n  margin-right: auto;\n}\n@media (max-width: 991px) {\n  .contentContainer___2IU4c {\n    padding: 60px 20px;\n  }\n}\n", ""]);

// exports
exports.locals = {
	"contentContainer": "contentContainer___2IU4c"
};


//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":false,"modules":true,"localIdentName":"[local]___[hash:base64:5]"}!./node_modules/less-loader/dist/cjs.js!./src/components/manage/website/entities/RegistryContainer/RegistryOnboardContainer/components/SectionContainer/SectionContainer.module.less
// module id = 1862
// module chunks = 51